module.exports = __webpack_public_path__ + "img/logo_color.d0c8e5ce.svg";